/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { PatternString } from "@pagopa/ts-commons/lib/strings";

// required attributes
const CreditorInstitutionAddressR = t.interface({});

// optional attributes
const CreditorInstitutionAddressO = t.partial({
  city: t.string,

  country_code: PatternString("^\\w{2}$|^$"),

  location: t.string,

  tax_domicile: t.string,

  zip_code: PatternString("^\\d{5}$|^$")
});

export const CreditorInstitutionAddress = t.intersection(
  [CreditorInstitutionAddressR, CreditorInstitutionAddressO],
  "CreditorInstitutionAddress"
);

export type CreditorInstitutionAddress = t.TypeOf<
  typeof CreditorInstitutionAddress
>;
